import { Typography } from '@material-ui/core';
import { RegistrationRequestStatusType } from 'features/auth/ts';
import VerificationApproved from 'assets/icons/verification-approved.svg';
import VerificationFailed from 'assets/icons/verification-failed.svg';
import VerificationInProcess from 'assets/icons/verification-in-process.svg';
import VerificationPending from 'assets/icons/warning.svg';
import { useTranslation } from 'hooks/useTranslation';
import { useStyles } from './styles';
import React from 'react';
import { User } from 'features/user/ts';

interface RegistrationRequestStatusProps {
  onShowUploadVerificationDocumentsModal: (isReUpload: boolean) => void;
  user: User;
}

export const RegistrationRequestStatus: React.FC<RegistrationRequestStatusProps> = ({
  onShowUploadVerificationDocumentsModal,
  user,
}) => {
  const { t } = useTranslation('auth');
  const classes = useStyles();
  let statusObject;

  switch (user?.registration_request_status) {
    case RegistrationRequestStatusType.APPROVED:
      statusObject = {
        img: VerificationApproved,
        text: t('messages.successfullyVerified'),
        link: null,
        color: '#00B2AE',
      };
      break;
    case RegistrationRequestStatusType.PENDING_VERIFICATION:
      statusObject = {
        img: VerificationPending,
        text: t('messages.verificationPending'),
        link: t('messages.verifyNow'),
        color: '#233B58',
      };
      break;
    case RegistrationRequestStatusType.PENDING_ACTION:
      statusObject = {
        img: VerificationFailed,
        text: t('messages.verificationFailed'),
        link: t('messages.uploadDocumentAgain'),
        color: '#FF0000',
      };
      break;
    case RegistrationRequestStatusType.PENDING_REVIEW:
      statusObject = {
        img: VerificationInProcess,
        text: t('messages.verificationInProcess'),
        link: null,
        color: '#233B58',
      };
      break;
    default:
      break;
  }

  const clickHandler = () => {
    const isReUpload = user && user.registration_request_status === RegistrationRequestStatusType.PENDING_ACTION;

    onShowUploadVerificationDocumentsModal(isReUpload);
  };

  return statusObject ? (
    <div className={classes.statusWrapper}>
      <img src={statusObject.img} alt="status icon" />
      <Typography className={classes.statusText} style={{ color: statusObject.color }}>
        {statusObject.text}
      </Typography>
      {statusObject.link && (
        <Typography className={classes.link} onClick={clickHandler}>
          {statusObject.link}
        </Typography>
      )}
    </div>
  ) : null;
};
